import { addYears } from 'date-fns';
import produce from 'immer';
import Cookies from 'universal-cookie';

import type CookieNames from '@swf/core/types/Cookies';
import type { Counter, Notification } from '@swf/core/types/Notification';

import type { NotificationState } from './index';

const cookies = new Cookies();

const reducers = {
  set: (
    state: NotificationState,
    { name, value }: { name: CookieNames; value: boolean }
  ): NotificationState => {
    cookies.set(name, value, { expires: addYears(new Date(), 1), path: '/' });

    return produce(state, (draft) => {
      draft.cookies[name] = value;
    });
  },
  addIssued: (state: NotificationState, payload: Notification): NotificationState =>
    produce(state, (draft) => {
      draft.issued[payload.rollId] = { ...(draft.issued[payload.rollId] || {}), ...payload };
    }),
  addExpiring: (state: NotificationState, payload: Notification): NotificationState =>
    produce(state, (draft) => {
      draft.expiring[payload.rollId] = payload;
    }),
  addCleared: (state: NotificationState, payload: Notification): NotificationState =>
    produce(state, (draft) => {
      draft.cleared[payload.rollId] = payload;
    }),
  addCounter: (state: NotificationState, payload: Counter): NotificationState =>
    produce(state, (draft) => {
      draft.counters = { ...state.counters, ...payload };
    }),
  reset: (state: NotificationState): NotificationState => ({
    ...state,
    issued: {},
    expiring: {},
    cleared: {},
    counters: { freeBetCounter: 0, freeSpinCounter: 0, instantBonusCounter: 0, prizeGameCounter: 0 }
  })
};

export default reducers;
